export default __webpack_public_path__ + "static/media/wrong-answer.e08b616b.mp3";